import React from "react";

import styles from "./Questionnare.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";
import { Link } from "react-router";
import QuestionnareInput from "../../../UI/Questionnary/QuestionnareInput/QuestionnareInput";

const DEFAULT_QUESTIONARY = {
  name: "",
  surname: "",
  tel: "+7",
  email: "",
  site: "",
  companyName: "",
  inn: "",
  samples: "",
};

const Questionnare: React.FC = () => {
  const [questionnaryData, setQuestionnaryData] = React.useState(DEFAULT_QUESTIONARY);
  const [isChecked, setIsChecked] = React.useState(false);

  const handleInputChange = (fieldName: string, value: string) => {
    setQuestionnaryData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const onFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isChecked) return;

    console.log(questionnaryData);
  };

  return (
    <section>
      <div className="container">
        <div className={styles.info}>
          <PreviousPage currentPage="Анкета для предоставления образцов" title="Анкета для предоставления образцов" />
          <p className={styles.text}>
            Предоставляем образцы юридическим лицам и компаниям. Образцы предаставляются бесплатно, доставка осуществляется после
            100% оплаты транспортных услуг.
          </p>
        </div>
        <div className={styles.body}>
          <form onSubmit={onFormSubmit} className={styles.form}>
            <h3 className={styles.title}>Анкета</h3>
            <div className={styles.fields}>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Имя"
                  name="name"
                  isRequired={true}
                  defaultValue={questionnaryData.name}
                  onChange={(value) => handleInputChange("name", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Фамилия"
                  name="surname"
                  isRequired={true}
                  defaultValue={questionnaryData.surname}
                  onChange={(value) => handleInputChange("surname", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Телефон"
                  name="tel"
                  isRequired={true}
                  isTel={true}
                  defaultValue={questionnaryData.tel}
                  onChange={(value) => handleInputChange("tel", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="E-mail"
                  name="email"
                  isRequired={true}
                  isEmail={true}
                  defaultValue={questionnaryData.email}
                  onChange={(value) => handleInputChange("email", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Сайт"
                  name="site"
                  isRequired={false}
                  defaultValue={questionnaryData.site}
                  onChange={(value) => handleInputChange("site", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Название компании"
                  name="companyName"
                  isRequired={true}
                  defaultValue={questionnaryData.companyName}
                  onChange={(value) => handleInputChange("companyName", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="ИНН"
                  name="inn"
                  isRequired={true}
                  defaultValue={questionnaryData.inn}
                  onChange={(value) => handleInputChange("inn", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Интересующие образцы тканей"
                  name="samples"
                  isRequired={true}
                  defaultValue={questionnaryData.samples}
                  onChange={(value) => handleInputChange("samples", value)}
                />
              </div>
            </div>
            <p className={styles.agreement}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                id="sample-agreement"
                required
              />
              <Link to="/privacy">
                Нажимая кнопку, я даю согласие на обработку моих персональных данных с целью рассмотрения заявки и отправки
                демонстрационных образцов товаров в соответствии с Политикой конфиденциальности
              </Link>
            </p>
            <div className={styles.samples}>
              <button type="submit" disabled={!isChecked}>Запросить образцы</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Questionnare;
